<template>
  <div class="auth-content">
    <div class="top-bg">
      <img class="top-bg-img" src="@/assets/auth/top-bg.png" alt="auth" />
    </div>
    <div class="sn-box">
      <div v-if="deviceList.length" class="sn-card">
        <div class="sn-title-box">
          <div class="sn-title">当前设备</div>
          <div class="sn-change-btn" @click="show = true">
            <van-icon name="sort" size="16px" color="var(--primary-color)" />
            <span>切换设备</span>
          </div>
        </div>
        <div class="sn-content-box">
          <div class="sn-content-img">
            <img
              class="device-img"
              :src="
                deviceUrl
                  ? deviceUrl
                  : require('@/assets/images/home/device.png')
              "
            />
          </div>
          <div class="sn-content-info">
            <div class="sn-content-info-name">{{ deviceTypeName }}</div>
            <div class="sn-content-info-id">设备编号：{{ deviceSN }}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="deviceList.length" class="tip-box">
      您的身份信息将直接提交给运营商，请放心实名
    </div>
    <!-- 实名登记卡列表 -->
    <div v-if="deviceList.length" class="list-box">
      <div class="card-item" v-for="(card, index) in authCardList" :key="index">
        <div
          class="updata-btn"
          v-if="card.certifyState === 0"
          @click="updateAuthCardStatusEvent(card)"
        >
          <van-icon
            name="replay"
            size="12px"
            style="font-weight: bold"
            color="var(--primary-color)"
          />
          <span>更新状态</span>
        </div>
        <div class="card-top-box">
          <div class="card-img-box">
            <img
              class="card-img"
              :src="getOperatorLogo(card.isp)"
            />
            <span
              class="card-text"
              :style="{
                background: card.certifyState === 0 ? '#FF0100' : '#0FB176',
              }"
              >{{ card.certifyState === 0 ? "未实名" : "已实名" }}</span
            >
          </div>
          <div class="card-info-box">
            <div class="card-info-name">{{ card.ispName }}</div>
            <div class="card-info-id">ICCID：{{ card.iccid }}</div>
          </div>
        </div>
        <div class="card-line"></div>
        <div
          class="card-btn"
          @click="handleAuth(card)"
          :class="{ active: card.certifyState === 0 }"
        >
          {{ card.buttonText }}
        </div>
        <div v-if="card.certifyState === 0" class="card-remark-box">
          <div v-if="card.unRegisterContent" class="card-remark">
            {{ card.unRegisterContent }}
          </div>
          <div class="card-remark">如完成实名后状态未更新，请手动更新状态</div>
        </div>
      </div>
    </div>
    <!-- 暂无设备 -->
    <div v-if="!deviceList.length" class="auth-no-device">
      <img class="package-empty-icon" src="@/assets/empty-order.png" />
      <p class="package-empty-text">
        暂无设备?<span class="package-empty-text-tip" @click="goAddDevice"
          >立即添加</span
        >
      </p>
    </div>

    <!-- 实名弹窗 -->
    <div class="popup-overlay" v-if="showPopup && deviceList.length">
      <div class="popup">
        <p class="popup-title">提示</p>
        <p class="popup-content">
          根据《中华人民共和国网络安全法》及电信业务管理规定，用户须通过有效身份证件完成实名登记后方可正常使用移动WiFi。所填信息须真实准确，提供虚假资料将导致服务终止并承担法律责任。运营商有权核验身份信息并依法处理未实名用户，用户需及时更新变更信息，通信数据依规安全管理。
        </p>

        <div class="popup-content-line"></div>
        <button
          class="popup-button"
          :disabled="countdown > 0"
          @click="closePopup"
        >
          我已知晓<span v-if="countdown > 0">({{ countdown }}s)</span>
        </button>
      </div>
    </div>
    <!-- 切换设备弹窗 -->
    <van-popup v-model="show" round position="bottom">
      <div class="switch-device-header">
        <img
          class="switch-device-header-close"
          @click="show = false"
          src="@/assets/images/home/close.png"
        />
        <p class="switch-device-header-title">切换设备</p>
      </div>

      <div
        class="switch-device-item"
        v-for="device in deviceList"
        :key="device.id"
      >
        <img
          class="switch-icon"
          :src="
            device.picUrl
              ? device.picUrl
              : require('@/assets/images/home/device.png')
          "
        />

        <div>
          <p class="switch-device-item-title">{{ device.modelName }}</p>
          <p class="switch-device-item-title-tip">{{ device.sn }}</p>
        </div>

        <van-radio
          :name="device.id"
          v-model="selectedDeviceId"
          checked-color="var(--primary-color)"
          class="switch-device-item-radio"
        ></van-radio>
      </div>

      <button
        class="switch-device-confirm-button"
        @click="updateDeviceIDAction"
      >
        确定
      </button>
    </van-popup>
  </div>
</template>

<script>
import {
  getAuthCardList,
  completeAuth,
  getUserDeviceList,
  updateAuthCardStatus,
} from "@/api/home";
export default {
  data() {
    return {
      brandId: "",
      isFirst: false, //是否从绑机进来
      isBefore: false, //是否从manger进来
      showPopup: false,
      countdown: 3,
      deviceUrl: "",
      deviceTypeName: "",
      deviceSN: "",
      authCardList: [],
      show: false,
      selectedDeviceId: "",
      deviceList: [],
      resultUrl: "",

      logoMap: {
        T: require("@/assets/auth/dianxin.png"),
        M: require("@/assets/auth/yidong.png"),
        U: require("@/assets/auth/liantong.png"),
      },
    };
  },
  mounted() {
    ///接受外部SN
    this.deviceSN = this.$route.query.sn;
    this.isFirst = this.$route.query.isFirst;
    this.isBefore = this.$route.query.isBefore;

    this.getUserDeviceListAction();

    if (this.isFirst) {
      this.showPopup = true;
      this.startCountdown();
    } else {
      this.showPopup = false;
    }

    // 监听 popstate 底部返回按钮监听
    this.popstateHandler = this.handlePopState.bind(this);
    window.addEventListener("popstate", this.popstateHandler);
  },

  beforeDestroy() {
    // 销毁监听
    window.removeEventListener("popstate", this.handlePopState);
  },

  methods: {
    handlePopState() {
      if (this.isBefore) {
        window.location.replace("/pages/home/index");
      }
    },

    startCountdown() {
      const timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(timer);
        }
      }, 1000);
    },
    closePopup() {
      this.showPopup = false;
    },

    ///去添加设备
    goAddDevice() {
      /// 畅捷 还是h5绑机
      if (this.appData.brandId == "P0007") {
        this.uni.navigateTo("/home/addDevice");
      } else {
        ///进入小程序绑机
        this.uni.navigateTo("/home/enterWX");
      }
    },

    ///获取实名登记卡列表
    getAuthCardListAction() {
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });

      getAuthCardList({
        sn: this.deviceSN,
      })
        .then((res) => {
          this.$toast.clear();
          if (!res || !Array.isArray(res)) {
            return;
          }
          // 处理运营商显示名称
          this.authCardList = res.map((item) => {
            const ispMap = {
              T: "中国电信",
              M: "中国移动",
              U: "中国联通",
            };
            return {
              ...item,
              unRegisterContent:
                item.certifyState === 1 ? "" : item.unRegisterContent,
              ispName: ispMap[item.isp] || "未知运营商",
              buttonText: item.certifyState === 1 ? "已完成实名" : "去实名",
              cardVendorCode: item.cardVendorCode, //卡商标识(HL.享连 YT.亿通 JL.集流 XB.小犇)
            };
          });
        })
        .catch(() => {
          this.authCardList = [];
        });
    },

    ///获取运营商logo
    getOperatorLogo(isp) {
      return this.logoMap[isp] || "";
    },

    ///完成实名登记
    handleAuth(card) {
      if (card.certifyState === 1) {
        return;
      }
      //联通卡需要跳转至联通实名登记页面
      //  && card.cardVendorCode === "XB"
      if (card.isp === "U") {
        if (card.iccid) {
          this.uni.navigateTo("/home/chinaUnicom?iccid=" + card.iccid);
        } else {
          this.$toast.fail("认证地址有误！");
        }
      } else {
        completeAuth({
          iccid: card.iccid,
        }).then((res) => {
          if (res) {
            window.location.href = res;
          } else {
            //弹窗提示
            this.$toast.fail("认证地址有误！");
          }
        });
      }
    },

    ///获取设备列表
    getUserDeviceListAction() {
      getUserDeviceList().then((res) => {
        // 转换设备列表数据
        this.deviceList = res.map((item) => ({
          id: item.id,
          modelName: item.modelName,
          sn: item.sn,
          picUrl: item.picUrl,
        }));

        // 检查保存的设备ID是否在当前设备列表中
        if (this.deviceList.length > 0) {
          // 处理设备ID
          const savedDeviceID = this.$store.getters.getDeviceID;

          var selectDevice;

          if (this.deviceSN) {
            selectDevice = this.deviceList.find(
              (device) => device.sn === this.deviceSN,
            );
          } else {
            selectDevice = this.deviceList.find(
              (device) => device.id === savedDeviceID,
            );
          }

          if (!selectDevice) {
            selectDevice = this.deviceList[0];
          }

          if (selectDevice) {
            this.selectedDeviceId = selectDevice.id;
            this.deviceSN = selectDevice.sn;
            this.deviceTypeName = selectDevice.modelName;
            this.deviceUrl = selectDevice.picUrl;

            this.getAuthCardListAction();
          }
        }
      });
    },

    ///切换设备-确认按钮点击事件
    updateDeviceIDAction() {
      if (!this.selectedDeviceId) {
        this.$toast.fail("请选择设备");
        return;
      }

      // 获取选中设备的信息
      const selectedDevice = this.deviceList.find(
        (device) => device.id === this.selectedDeviceId,
      );
      if (selectedDevice) {
        this.deviceSN = selectedDevice.sn;
        this.deviceName = selectedDevice.modelName;
        this.deviceUrl = selectedDevice.picUrl;

        this.getAuthCardListAction();
      }
      // 关闭弹窗
      this.show = false;
    },

    updateAuthCardStatusEvent(card) {
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      updateAuthCardStatus({
        iccid: card.iccid,
      }).then((res) => {
        this.$toast.clear();
        this.getAuthCardListAction();
      });
    },
  },
};
</script>
<style lang="scss">
#app {
  background-color: #f2f2f2 !important;
}
</style>
<style lang="scss" scoped>
.auth-content {
  position: relative;
  .top-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 352px;
    z-index: 1;
    .top-bg-img {
      width: 100%;
      height: 100%;
    }
  }

  .sn-box {
    padding-top: 312px;
    .sn-card {
      position: relative;
      z-index: 2;
      width: 698px;
      height: 208px;
      margin: 0 auto;
      background: url("../../assets/auth/sn-bg.png") center no-repeat #fff;
      background-size: 100% 100%;
      padding: 22px;
      box-sizing: border-box;
      border: 2px solid #ffffff;
      border-radius: 22px;
      .sn-title-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .sn-title {
          font-size: 30px;
          color: #000000;
          font-weight: bold;
        }
        .sn-change-btn {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 156px;
          height: 44px;
          background-color: var(--subs2-color) #fbf1ea;
          border-radius: 22px;
          border: 2px solid var(--primary-color);
          font-size: 24px;
          color: var(--primary-color);
        }
      }
      .sn-content-box {
        margin-top: 20px;
        display: flex;
        align-items: center;
        gap: 16px;
        .sn-content-img {
          width: 88px;
          height: 88px;
          .device-img {
            width: 100%;
            height: 100%;
          }
        }
        .sn-content-info {
          .sn-content-info-name {
            font-weight: bold;
            font-size: 30px;
            color: #000000;
          }
          .sn-content-info-id {
            margin-top: 8px;
            font-size: 24px;
            color: #848992;
          }
        }
      }
    }
  }

  .tip-box {
    padding: 0 32px;
    margin: 32px 0;
    text-align: center;
    font-size: 26px;
    color: var(--primary-color);
    position: relative;
    &::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 32px;
      transform: translate(0, -50%);
      width: 62px;
      height: 1px;
      background-color: var(--subs5-color);
    }
    &::before {
      content: "";
      position: absolute;
      top: 50%;
      right: 32px;
      transform: translate(0, -50%);
      width: 62px;
      height: 1px;
      background-color: var(--subs5-color);
    }
  }

  .list-box {
    .card-item {
      width: 702px;
      padding: 24px;
      box-sizing: border-box;
      margin: 0 auto 20px;
      background: #ffffff;
      border-radius: 24px;
      position: relative;
      .updata-btn {
        position: absolute;
        top: 24px;
        right: 24px;
        font-size: 24px;
        color: var(--primary-color);
        display: flex;
        align-items: center;
        gap: 4px;
      }
      .card-top-box {
        display: flex;
        align-items: center;
        gap: 20px;
        .card-img-box {
          width: 124px;
          height: 124px;
          position: relative;
          .card-img {
            width: 100%;
            height: 100%;
          }

          .card-text {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 124px;
            height: 36px;
            border-radius: 6px 6px 16px 16px;
            font-size: 24px;
            color: #ffffff;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
        .card-info-box {
          .card-info-name {
            font-size: 32px;
            color: #3e3e41;
            font-weight: bold;
          }
          .card-info-id {
            font-size: 24px;
            color: #848992;
            margin-top: 12px;
          }
        }
      }
      .card-line {
        margin: 24px 0;
        width: 654px;
        height: 2px;
        background: #f2f2f2;
      }

      .card-btn {
        width: 654px;
        height: 84px;
        background: #efefef;
        border-radius: 12px 12px 12px 12px;
        line-height: 84px;
        text-align: center;
        font-size: 30px;
        color: #bababa;
        &.active {
          background: var(--primary-color);
          color: #ffffff;
        }
      }

      .card-remark-box {
        margin-top: 24px;
        padding: 0 24px;
        box-sizing: border-box;
        .card-remark {
          padding-left: 12px;
          font-size: 24px;
          color: #999999;
          margin-bottom: 10px;
          position: relative;
          &::before {
            content: "*";
            position: absolute;
            top: 5px;
            left: -10px;
            color: #ff0100;
            font-size: 28px;
          }
        }
      }
    }
  }
}

.switch-device-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px;
}

.switch-device-header-close {
  width: 48px;
  height: 48px;
}

.switch-device-header-title {
  flex: 1;
  text-align: center;
  font-weight: 700;
  font-size: 36px;
  color: var(--text-color);
}

.switch-device-header-add-container {
  display: flex;
  align-items: center;
}

.switch-device-header-add {
  width: 36px;
  height: 36px;
}

.switch-device-header-add-text {
  font-size: 32px;
  color: var(--primary-color);
  margin-left: 8px;
}

.switch-icon {
  width: 112px;
  height: 112px;
  object-fit: contain;
  padding: 10px;
}

.switch-device-item {
  display: flex;
  align-items: center;
  margin-left: 32px;
  margin-right: 32px;
  margin-top: 32px;
  background-color: #f7f8fa;
  border-radius: 20px;
}

.switch-device-item-title {
  font-size: 30px;
  color: #000000;
  padding-left: 8px;
  margin-bottom: 4px;
}

.switch-device-item-title-tip {
  font-size: 26px;
  color: #848992;
  padding-left: 8px;
  margin-top: 0px;
}

.switch-device-item-radio {
  margin-left: auto;
  margin-right: 32px;
}

.switch-device-confirm-button {
  background-color: var(--primary-color);
  border: none;
  border-radius: 20px;
  height: 100px;
  width: calc(100% - 64px);
  margin: 60px 32px 80px;
  color: #ffffff;
}

.auth-no-device {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .package-empty-icon {
    margin-top: 120px;
    width: 342px;
    height: 264px;
  }

  .package-empty-text {
    font-size: 30px;
    color: #666666;
    margin-top: 72px;

    .package-empty-text-tip {
      color: var(--primary-color);
    }
  }
}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  .popup {
    background-color: white;
    border-radius: 32px;
    margin-left: 60px;
    margin-right: 60px;
    text-align: center;
    position: relative;
  }

  .popup-title {
    padding-top: 32px;
    font-size: 34px;
    font-weight: bold;
    // margin-bottom: 15px;
    color: #1d2129;
  }

  .popup-content {
    padding: 16px 32px;
    font-size: 28px;
    color: #4e5969;
    line-height: 1.5;
    margin-bottom: 32px;
  }

  //下划线

  .popup-content-line {
    width: 100%;
    height: 1px;
    background-color: #e5e6eb;
    margin-bottom: 32px;
  }

  .popup-button {
    background-color: transparent;
    color: var(--primary-color);
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    font-size: 32px;
    cursor: pointer;
    margin-bottom: 30px;
  }

  .popup-button:disabled {
    color: #ccc;
  }
}
</style>
